
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as ModelPrincipal } from '../../controlador';
    import { Controlador as Model } from './controlador';
    import barra from './barra-lateral.vue';
    import sala from './sala/sala.vue';
    import { Wait } from '@/__env/ext';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            barra,
            sala,
        }
    } )
    export default class Componente extends Vue
    {
        public get Principal() { return Vue.observable( ModelPrincipal ); }
        public get Controlador() { return Vue.observable( Model ); }
        public get Buscador() { return this.Controlador.Buscador; }
        public get Seleccionado() { return this.Controlador.Seleccionado; }
        public get MenuOculto() { return this.Controlador.Vista.MenuOculto; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async created()
        {
            await this.Controlador.Iniciar();
        }

        async mounted()
        {
            let cliente = this.$route.query.cliente_id;
            let pack = this.$route.query.pack;

            await Wait( 1000 );

            if ( cliente )
            {
                this.Controlador.Buscador.Filtros.Valores.Cliente = cliente;
                await this.Controlador.Buscador.Buscar(1);
                if ( this.Controlador.Buscador.Items.hasRows() )
                {
                    this.Controlador.Seleccionado = this.Controlador.Buscador.Items[0];
                }
                this.Controlador.Buscador.Filtros.Valores.Cliente = 0;
            }

            else if ( pack )
            {
                this.Controlador.Buscador.Filtros.Valores.Pack = pack;
                await this.Controlador.Buscador.Buscar(1);
                if ( this.Controlador.Buscador.Items.hasRows() )
                {
                    this.Controlador.Seleccionado = this.Controlador.Buscador.Items[0];

                }

                this.Controlador.Buscador.Filtros.Valores.Pack = 0;
            }

            await Wait( 1000 );

            //this.Controlador.Buscador.Filtros.set( this.$route.query );
            await this.Controlador.Buscador.Buscar();


        }


    }
